<template>
  <div
    v-if="selfieLoaded"
    class="selfie-preview"
    :class="{
      'selfie-preview-expanded': isSelfiePreviewExpanded,
    }"
    :style="selfiePreviewVisibilityStyle"
  >
    <div class="expand-contract-button" :class="{ 'expanded-state': isSelfiePreviewExpanded }">
      <img class="svg-img" src="@/assets/avbuilder_expandcontractphoto.svg" draggable="false" />
    </div>

    <div class="selfie-preview-interior-stroke" @click="onExpandContractTap"></div>

    <div v-if="isSelfiePreviewExpanded" class="delete-button" @click="onDeleteSelfieTap">
      <img class="svg-img" src="@/assets/avbuilder_trashphoto.svg" draggable="false" />
    </div>

    <img :src="selfieImage" draggable="false" />
  </div>
</template>

<script>
import ReceiveClientMessage from '@/services/ReceiveClientMessage';
import SendClientMessage from '@/services/SendClientMessage';

const SELFIE_BASE64_JPEG_PREFIX = 'data:image/jpeg;base64,';

export default {
  name: 'SelfiePreview',
  props: [
    'isFullBodyCategory', // :Boolean
  ],
  data: function() {
    return {
      selfieImage: '',
      selfieLoaded: false,
    };
  },
  created: function() {
    // Listen for "Set Selfie" events.
    ReceiveClientMessage.SetSelfieEventBus.$on('set', this.onSetSelfie);
    // Send message to the client to load the selfie.
    SendClientMessage.loadSelfie();
  },
  computed: {
    isSelfiePreviewDismissed() {
      return this.$store.getters.isSelfiePreviewDismissed;
    },
    isSelfiePreviewExpanded() {
      return this.$store.getters.isSelfiePreviewExpanded;
    },
    selfiePreviewVisibilityStyle() {
      const shouldHideSelfiePreview = this.isSelfiePreviewDismissed || this.isFullBodyCategory;
      if (shouldHideSelfiePreview) {
        // To hide the selfie preview, transition it just below the bottom half of the builder.
        const selfiePreviewHeight = this.isSelfiePreviewExpanded
          ? 'calc(2 * var(--selfie-preview-height))'
          : 'var(--selfie-preview-height)';
        return {
          // 4px in the expression below is the blur radius of the container's shadow.
          bottom: `calc(100% - var(--top-half-height) - ${selfiePreviewHeight} - 4px)`,
        };
      } else {
        // Do nothing.
        return {};
      }
    },
  },
  methods: {
    onSetSelfie: function(data) {
      if (data.startsWith(SELFIE_BASE64_JPEG_PREFIX)) {
        this.selfieImage = data;
        this.selfieLoaded = true;
      }
    },
    onDeleteSelfieTap: function() {
      this.$store.commit('setShouldShowDeleteSelfieDialog', { show: true });
    },
    onExpandContractTap: function() {
      const isExpanded = this.$store.getters.isSelfiePreviewExpanded;
      this.$store.commit('setIsSelfiePreviewExpanded', { isExpanded: !isExpanded });
    },
  },
};
</script>

<style scoped>
.selfie-preview {
  position: absolute;
  width: var(--selfie-preview-width);
  height: var(--selfie-preview-height);
  right: 7px;
  bottom: calc(100% - var(--top-half-height) + 10px);
  transition: width 0.3s, height 0.3s, bottom 0.3s;
  border: 0.5px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.24);
  border-radius: 12px;
}

.selfie-preview-expanded {
  width: calc(2 * var(--selfie-preview-width));
  height: calc(2 * var(--selfie-preview-height));
}

.selfie-preview-interior-stroke {
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-sizing: border-box;
  border-radius: 12px;
}

.selfie-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
}

.delete-button {
  position: absolute;
  width: 32px;
  height: 32px;
  right: 5px;
  bottom: 5px;
}

.expand-contract-button {
  position: absolute;
  width: 24px;
  height: 24px;
  left: -1px;
  top: -1px;
  transform: matrix(0, 1, 1, 0, 0, 0);
  transition: transform 0.3s, left 0.3s, top 0.3s;
}

.expand-contract-button.expanded-state {
  left: 2px;
  top: 2px;
  transform: matrix(0, -1, -1, 0, 0, 0);
}
</style>
